import { Box, Typography } from "@mui/material";
import { CommitmentsGraph, CommitmentsStates, CommitmentsList } from "../components";

export const CommitmentsExposure = () => {
    return (
        <Box py={2}>
            <Box display={'flex'} flexDirection={'column'} alignItems={'start'} px={2} mb={2}>
                <Typography variant="subtitle1" color="text.primary">Commitments & Exposure</Typography>
                <Typography variant="caption" color="text.secondary">Programme commitment analysis and remaining budget exposure</Typography>
            </Box>
            <CommitmentsGraph />
            <CommitmentsStates />
            <CommitmentsList />
        </Box>
    );
};